import { RecalculatePriceStrategy } from '../types';
import {
  noOpQuantityChange,
  noOpQuotePriceCreation,
  noOpUnitPrice,
} from './no-op';

export const recalculateNewPartUserPrice = {
  onQuantityChange: noOpQuantityChange,
  onUnitPriceChange: noOpUnitPrice,
  onGrossMarginChange: null,
  onContributionMarginChange: null,
  onBaseGrossMarginChange: null,
  onQuotePriceCreation: noOpQuotePriceCreation,
  onUnitCostChange: null,
} satisfies RecalculatePriceStrategy;
